export default {
    headerHeight: 120,
    headerSticky: 70
};
